export const conversationKeys = {
  all: ["conversation"] as const,
  lists: () => [...conversationKeys.all, "list"] as const,
  list: (filters: object) => [...conversationKeys.lists(), filters] as const,
  details: () => [...conversationKeys.all, "detail"] as const,
  detail: (id: string) => [...conversationKeys.details(), id] as const,
};

export default conversationKeys;
